import { useEffect, useRef } from 'react'
import type { ParticipanteAoVivo } from './sala-mesh.ts'

/**
 * Quem entrou pelo link, numa miniatura ao lado das minhas (SPEC-20260917-0047).
 * Sem câmera, mostra o nome — a etiqueta de quem é sempre fica visível, porque
 * é gente de fora e saber quem está ouvindo importa.
 */
export function VideoDoConvidado({ participante }: { participante: ParticipanteAoVivo }) {
  const video = useRef<HTMLVideoElement>(null)

  useEffect(() => {
    if (video.current) video.current.srcObject = participante.camera
  }, [participante.camera])

  return (
    <div className="vc-convidado">
      <video
        ref={video}
        className="vc-convidado__video"
        autoPlay
        playsInline
        hidden={!participante.midia.video}
      />
      {participante.midia.video ? null : (
        <span className="vc-convidado__semvideo" aria-hidden>
          {iniciais(participante.nome)}
        </span>
      )}
      <span className="vc-convidado__nome">
        <i className="fas fa-link" aria-hidden /> {participante.nome}
      </span>
    </div>
  )
}


function iniciais(nome: string): string {
  const partes = nome.trim().split(/s+/)
  return ((partes[0]?.[0] ?? '') + (partes.length > 1 ? (partes[partes.length - 1]?.[0] ?? '') : '')).toUpperCase()
}
